import { Alert } from "@mui/material";
import { errorToast, successToast } from "../../toast";
import Button from "../Button";
import { useMakePrimary } from "../../api/emissions-sources";
import FormTextInput from "../FormTextInput";
import {
    MakePrimaryFormValues,
    makePrimaryFormValidationSchema,
} from "./MakePrimaryFormValues";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

type MakePrimaryFormProps = {
    emissionsSourceid: number;
    onCancel: () => void;
    onSubmit: () => void;
};

const MakePrimaryForm = ({
    emissionsSourceid,
    onCancel,
    onSubmit,
}: MakePrimaryFormProps) => {
    const methods = useForm<MakePrimaryFormValues>({
        mode: "onSubmit",
        resolver: yupResolver(makePrimaryFormValidationSchema),
    });

    const [request, isSubmitting] = useMakePrimary(emissionsSourceid);

    const handleMakePrimaryFormSubmission = async (
        value: MakePrimaryFormValues
    ) => {
        const response = await request(value);

        if (!response.success) {
            errorToast(
                "There was a problem saving the emissions source - please try again"
            );
            return;
        }

        successToast("Emissions source updated");
        onSubmit();
    };

    return (
        <>
            <form
                onSubmit={methods.handleSubmit(handleMakePrimaryFormSubmission)}
            >
                <Alert severity="info" className="items-center">
                    Changing this emissions source to primary will not affect
                    its associated data source. All activity data will be
                    preserved.
                </Alert>
                <div className="space-y-4 mt-5">
                    <FormTextInput
                        required
                        type="text"
                        label="Justification"
                        placeholder="Enter justification for change"
                        {...methods.register("justification")}
                        error={methods.formState.errors.justification}
                    />
                </div>
                <div className="flex justify-end gap-4 mt-10">
                    <Button
                        variant="transparent"
                        type="button"
                        onClick={onCancel}
                    >
                        Cancel
                    </Button>
                    <Button disabled={isSubmitting} type="submit">
                        Make Primary
                    </Button>
                </div>
            </form>
        </>
    );
};

export default MakePrimaryForm;
